import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';

import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import {
    Insert as LAPU_INSERT,
    Select as LAPU_SELECT,
    Delete as LAPU_DELETE,
    Update as LAPU_UPDATE,
    SelectByID as SELECT_BY_ID
} from 'Components/Api/LapuAccountingAPI';
import { Select } from 'Components/Api/StatesApi';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Container,
    Grid,
    Paper,
    Button,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);

export const LapuAccounting = () => {
    const classes = commonStyle();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [severity, setSeverity] = useState('success');
    const [stateList, setStateList] = useState([]);

    const [itemList, setItemList] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [IsUpdate, setIsUpdate] = useState(false);
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }
        var requestObj = JSON.stringify(values);
        setSubmitting(false);
        setIsError(false);
        setLoading(true);

        var response = IsUpdate
            ? await LAPU_UPDATE(requestObj)
            : await LAPU_INSERT(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setSubmitting(true);

        setIsError(true);

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        setSeverity('success');

        resetForm(FormObj);
        resetForm(FormData);
        selectData();
        setTimeout(() => {}, MESSAGE_CLOSE_AFTER);
    };

    const FormValidationSchema = Yup.object({
        PartyName: Yup.string()
            .matches(/^[a-zA-Z]+$/, 'PartyName accept Characters only')
            .required(PLEASE_PROVIDE_VALID + 'party name'),

        MobileNumber: Yup.string()
            .trim()
            .length(10, PLEASE_PROVIDE_VALID + 'mobile number')
            .required(PLEASE_PROVIDE_VALID + 'mobile number')
    });

    const selectData = async () => {
        const { isAuthorized, status, data } = await LAPU_SELECT();

        setLoading(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data);

            return;
        }
        var d = JSON.parse(data);

        setItemList(d);
    };

    const onDeleteClick = async (LapuPartyMasterID) => {
        let jsonObj = {
            LapuPartyMasterID: LapuPartyMasterID
        };
        setLoading(true);
        const response = await LAPU_DELETE(JSON.stringify(jsonObj));
        setLoading(false);

        const { isAuthorized, status, data } = response;
        if (!isAuthorized) LOGOUT();

        setIsError(true);

        if (!status) {
            setSeverity('error');
            setResponseMessage(data);
            return;
        }
        setSeverity('success');
        setResponseMessage(data);
        setTimeout(() => {
            selectData();
        }, MESSAGE_CLOSE_AFTER);
    };

    const Edit = async (LapuPartyMasterID) => {
        setIsUpdate(true);
        SelectByID(LapuPartyMasterID);
    };

    const SelectByID = async (LapuPartyMasterID) => {
        let jsonObj = {
            LapuPartyMasterID: LapuPartyMasterID
        };

        const response = await SELECT_BY_ID(JSON.stringify(jsonObj));

        //  if (!response.isAuthorized) LOGOUT();

        if (!response.status) return;

        var data = JSON.parse(response.data);

        setFormObj({
            LapuPartyMasterID: data.LapuPartyMasterID,
            StateID: data.StateID,
            Address: data.Address,
            PartyName: data.PartyName,
            City: data.City,
            MobileNumber: data.MobileNumber,
            EmailID: data.EmailID
        });
    };
    var FormData = {
        StateID: 0,
        Address: '',
        PartyName: '',
        City: '',
        MobileNumber: '',
        EmailID: ''
    };

    const [FormObj, setFormObj] = useState({
        StateID: 0,
        Address: '',
        PartyName: '',
        Address: '',
        City: '',
        MobileNumber: '',
        EmailID: ''
    });

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'LapuPartyMasterID',
            srno: true
        });

        columns.push({
            label: 'date',
            name: 'DOC'
        });
        columns.push({
            label: 'PartyName',
            name: 'PartyName'
        });
        columns.push({
            label: 'MobileNumber',
            name: 'MobileNumber'
        });

        columns.push({
            label: 'City',
            name: 'City'
        });

        columns.push({
            label: 'EmailID',
            name: 'EmailID'
        });
        columns.push({
            label: 'Address',
            name: 'Address'
        });
        columns.push({
            label: 'Edit',
            name: 'LapuPartyMasterID',
            edit: true,
            callback: (value) => {
                Edit(value);
            }
        });
        columns.push({
            label: 'Delete',
            name: 'LapuPartyMasterID',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });
        setMainColumns(columns);
    };

    const selectStates = async () => {
        const response = await Select();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setStateList(data);
    };

    useEffect(() => {
        selectStates();
        createColumns();
        selectData();
    }, []);

    const StateItems = stateList.map(({ StateID, Name }) => (
        <MenuItem key={StateID} value={StateID}>
            {Name}
        </MenuItem>
    ));

    const UploadForm = (formProps) => {
        return (
            <Grid
                item
                container
                margin="normal"
                xs={12}
                md={12}
                sm={12}
                lg={12}
                spacing={2}
            >
                <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Form>
                        <h2 className={classes.PaperHead_h2}>Lapu Party Add</h2>
                        <Paper className={classes.PaperStyle}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="PartyName"
                                        name="PartyName"
                                        type="text"
                                        placeholder="PartyName"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialNumberField
                                        label="MobileNumber"
                                        name="MobileNumber"
                                        type="text"
                                        length={10}
                                        placeholder="MobileNumber"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="EmailID"
                                        name="EmailID"
                                        type="text"
                                        placeholder="EmailID"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialSelect
                                        name="StateID"
                                        label="State"
                                        title="State"
                                    >
                                        <MenuItem key="0" value="0">
                                            State
                                        </MenuItem>
                                        {StateItems}
                                    </MaterialSelect>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="City"
                                        name="City"
                                        type="text"
                                        placeholder="City"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="Address"
                                        name="Address"
                                        type="text"
                                        placeholder="Address"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <SecondaryButton
                                        type="reset"
                                        variant="contained"
                                        color="secondary"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </SecondaryButton>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <PrimaryButton
                                        type="submit"
                                        title={IsUpdate ? 'Update' : 'Save'}
                                        className={
                                            classes.CustomPrimaryButtonStyle
                                        }
                                        disabled={loading}
                                    >
                                        {IsUpdate ? 'Update' : 'Save'}
                                    </PrimaryButton>
                                    {loading && (
                                        <CircularProgress
                                            size={24}
                                            className={classes.buttonProgress}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Paper>
                    </Form>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={8} className="Report">
                    <h2 className={classes.PaperHead_h2}>Lapu Party Details</h2>
                    <ReactTable data={itemList} columns={mainColumns} />
                </Grid>
            </Grid>
        );
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={FormObj}
            >
                {UploadForm}
            </Formik>
        </CustomContainer>
    );
};
